import React, { useState } from "react";
import CustomerHeader from "../components/CustomerHeader";
import CustomerFooter from "../components/CustomerFooter";

function Contact() {
  const [isMobile] = useState(window.innerWidth <= 768);

  return (
    <>
      <CustomerHeader />
      <div
        style={{
          padding: isMobile ? "86px 16px 30px" : "106px 32px 42px",
          background: "#f9fafb",
        }}
      >
        <div
          style={{
            maxWidth: "960px",
            margin: "0 auto",
            background: "white",
            borderRadius: "16px",
            padding: isMobile ? "24px" : "40px",
            border: "1px solid #e5e7eb",
          }}
        >
          <h1 style={{ marginTop: 0, color: "#111827" }}>Contact OGESTYLE</h1>
          <p style={{ color: "#4b5563", lineHeight: "1.7" }}>
            Need help with your account, bookings, payments, or onboarding? Reach out
            and our team will guide you.
          </p>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
              gap: "16px",
              marginTop: "24px",
            }}
          >
            <div style={{ padding: "20px", background: "#f3f4f6", borderRadius: "12px" }}>
              <h3 style={{ marginTop: 0, color: "#111827" }}>General Support</h3>
              <p style={{ marginBottom: "8px", color: "#374151" }}>support@mg.ogestyle.com</p>
              <p style={{ margin: 0, color: "#6b7280", fontSize: "14px" }}>
                For customers, businesses, and freelancers.
              </p>
            </div>

            <div style={{ padding: "20px", background: "#f3f4f6", borderRadius: "12px" }}>
              <h3 style={{ marginTop: 0, color: "#111827" }}>Business Onboarding</h3>
              <p style={{ marginBottom: "8px", color: "#374151" }}>partners@mg.ogestyle.com</p>
              <p style={{ margin: 0, color: "#6b7280", fontSize: "14px" }}>
                For salons, spas, and multi-location businesses.
              </p>
            </div>

            <div
              style={{
                padding: "20px",
                background: "linear-gradient(135deg, #eff6ff 0%, #f8fafc 100%)",
                borderRadius: "12px",
                border: "1px solid #bfdbfe",
              }}
            >
              <h3 style={{ marginTop: 0, color: "#111827" }}>Phone</h3>
              <a
                href="tel:+12244870005"
                style={{
                  display: "inline-block",
                  marginBottom: "8px",
                  color: "#1d4ed8",
                  fontWeight: 600,
                  textDecoration: "none",
                }}
              >
                (224) 487-0005
              </a>
              <p style={{ margin: 0, color: "#6b7280", fontSize: "14px" }}>
                Call for direct business support and onboarding questions.
              </p>
            </div>

            <div
              style={{
                padding: "20px",
                background: "#f9fafb",
                borderRadius: "12px",
                border: "1px solid #e5e7eb",
              }}
            >
              <h3 style={{ marginTop: 0, color: "#111827" }}>Location</h3>
              <p style={{ marginBottom: "8px", color: "#374151", fontWeight: 600 }}>
                Cary, IL
              </p>
              <p style={{ margin: 0, color: "#6b7280", fontSize: "14px" }}>
                Cary, Illinois.
              </p>
            </div>
          </div>

          <div style={{ marginTop: "24px", color: "#6b7280", fontSize: "14px" }}>
            Contact us for customer support, business onboarding, and account help.
          </div>
        </div>
      </div>
      <CustomerFooter />
    </>
  );
}

export default Contact;
